// src/pages/GDPR.tsx
const Terms = () => {
  return (
    <div>
      {/* Hero Section */}
      <section className="page-hero">
        <div 
          className="absolute inset-0 bg-cover bg-center bg-no-repeat"
          style={{ backgroundImage: "url('https://images.unsplash.com/photo-1569235186275-626cb53b83ce?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80')" }}
        ></div>
        <div className="container mx-auto px-4 relative z-10">
          <div className="hero-content max-w-2xl">
            <h1 className="text-4xl md:text-5xl font-bold mb-4">Pogoji uporabe</h1>
            <p className="text-xl">Splošni pogoji poslovanja</p>
          </div>
        </div>
      </section>

      {/* Content Section */}
      <section className="py-16">
        <div className="container mx-auto px-4">
          <div className="bg-white rounded-xl shadow-xl p-8 border border-gray-100 card-glow">
            <div className="max-w-4xl mx-auto">
              <h2 className="text-2xl font-bold mb-6">Splošni pogoji poslovanja</h2>

              <div className="space-y-6 text-gray-700">
                <p>
                  Spodaj navedeni splošni pogoji poslovanja urejajo pravna razmerja med podjetjem Avtoservis Vodnik in naročniki naših storitev.
                </p>

                <h3 className="text-xl font-semibold mt-8 mb-3">1. Splošne določbe</h3>
                <p>
                  Ti splošni pogoji poslovanja veljajo za vse storitve, ki jih ponuja Avtoservis Vodnik. Z naročilom naših storitev potrjujete, da ste seznanjeni s temi pogoji in se z njimi strinjate.
                </p>

                <h3 className="text-xl font-semibold mt-8 mb-3">2. Naročilo storitev</h3>
                <p>
                  Naročilo storitev lahko opravite osebno v naših prostorih, po telefonu ali preko elektronske pošte. Pri naročilu morate navesti svoje kontaktne podatke in informacije o vozilu ter želenih storitvah. Po sprejemu naročila vas bomo obvestili o predvidenem roku izvedbe in ceni storitev.
                </p>

                <h3 className="text-xl font-semibold mt-8 mb-3">3. Cene in plačilni pogoji</h3>
                <p>
                  Cene naših storitev so določene v veljavnem ceniku. Pridržujemo si pravico do spremembe cen brez predhodnega obvestila. V primeru, da med izvajanjem storitev ugotovimo potrebo po dodatnih delih, vas bomo o tem predhodno obvestili in pridobili vaše soglasje. Plačilo se izvede po zaključku opravljenih storitev v gotovini ali z bančno kartico.
                </p>

                <h3 className="text-xl font-semibold mt-8 mb-3">4. Garancija</h3>
                <p>
                  Za vse opravljene storitve nudimo garancijo skladno z zakonskimi določili. Garancija za vgrajene nadomestne dele je odvisna od garancijskih pogojev proizvajalca. Garancija ne velja v primeru nestrokovne uporabe, mehanskih poškodb, ki so posledica zunanjih vplivov, ali nepooblaščenih posegov v vozilo s strani tretjih oseb.
                </p>

                <h3 className="text-xl font-semibold mt-8 mb-3">5. Pravice in obveznosti strank</h3>
                <p>
                  Avtoservis Vodnik se zavezuje, da bo storitve opravil strokovno in v dogovorjenem roku. Naročnik se zavezuje, da bo zagotovil točne informacije o vozilu in omogočil dostop do vozila v dogovorjenem času. Naročnik je dolžan prevzeti vozilo v roku 3 dni po zaključku storitev, v nasprotnem primeru si pridržujemo pravico zaračunati stroške hrambe.
                </p>

                <h3 className="text-xl font-semibold mt-8 mb-3">6. Varovanje osebnih podatkov</h3>
                <p>
                  Vaše osebne podatke bomo varovali v skladu z našo politiko zasebnosti in veljavno zakonodajo. Za več informacij si oglejte našo GDPR politiko.
                </p>

                <h3 className="text-xl font-semibold mt-8 mb-3">7. Končne določbe</h3>
                <p>
                  Ti splošni pogoji poslovanja začnejo veljati z dnem objave na naši spletni strani. Pridržujemo si pravico do spremembe teh pogojev. Za morebitne spore, ki izhajajo iz teh pogojev, je pristojno sodišče v Mariboru.
                </p>

                <h3 className="text-xl font-semibold mt-8 mb-3">8. Kontaktne informacije</h3>
                <div className="bg-gray-50 p-4 rounded-lg my-4">
                  <p><strong>Avtoservis Vodnik</strong></p>
                  <p>Bukovec 10A, 2314 Zgornja Polskava</p>
                  <p>Email: milan_acko@t-2.net</p>
                  <p>Telefon: 041 273 738</p>
                </div>

                <p>
                  Zadnja posodobitev: {new Date().toLocaleDateString()}
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Terms;